import React from 'react';
import { Label, LabelProps } from '@patternfly/react-core';
import {
  EnhancedLiveClassOffering,
  LiveClassTableStatus,
} from 'types/liveClass';
import { ScheduleCellProps } from './types';

const StatusCell: React.FC<
  ScheduleCellProps & {
    getOfferingStatus?: (
      offering: EnhancedLiveClassOffering,
    ) => LiveClassTableStatus | null;
  }
> = ({ row, getOfferingStatus }) => {
  const offering = row?.original;

  if (!getOfferingStatus) {
    return offering.status || '';
  }

  const status = getOfferingStatus(offering);

  let color: LabelProps['color'] = 'grey';

  if (status === LiveClassTableStatus.Scheduled) {
    color = 'blue';
  } else if (status === LiveClassTableStatus.Available) {
    color = 'green';
  } else if (status === LiveClassTableStatus.Overlap) {
    color = 'orange';
  } else if (status === LiveClassTableStatus.Full) {
    color = 'grey';
  }

  return (
    <Label color={color} variant="filled">
      {status}
    </Label>
  );
};

export default StatusCell;
